import { WelcomePageGuard } from 'new-components/WelcomePageGuard/WelcomePageGuard';
import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { getOpParams } from 'utils/getOpParams';
import { MAILROOM_NATIVE_APP_ID, NativeAppStatus } from 'utils/nativeApps';
import { useFeatureFlag } from 'utils/customHooks/useFeatureFlag';
import { useFeatureGate } from 'utils/customHooks/useFeatureGate';

import { mailroomWelcomeRoute } from './constants/routes';

const MAILROOM_FEATURE_CODE = 'mailroom';

/**
 * @description Checks if the org has the Mailroom native app and if it is enabled.
 * If it is it outlets to the page the user navigated too otherwise it goes to the welcome page
 * for Mailroom to upsell
 */
export const MailroomWelcomePageGuard = () => {
  const { orgId } = getOpParams();

  const { data: mailroomNativeApp, isLoading: isNativeAppLoading } = useOpQuery(
    {
      apiEndpointName: 'listOrgNativeApps',
      parameters: [orgId],
      select: (heliumResponse) =>
        heliumResponse.json.data.find(
          (app) => app.nativeAppId === MAILROOM_NATIVE_APP_ID,
        ),
    },
  );
  const { value: isMailroomEnabledFF, isPending: isFeatureFlagPending } =
    useFeatureFlag<boolean>('ENABLE_MAILROOM', orgId);

  const { hasFeature: hasMailroomFeature, isPending: isFeaturePending } =
    useFeatureGate(MAILROOM_FEATURE_CODE, orgId);

  // if the mailroom feature flag is NOT enabled AND the mailroom native app does NOT exist or is not active
  const shouldShowWelcomePage = Boolean(
    !isMailroomEnabledFF &&
      !hasMailroomFeature &&
      !(
        mailroomNativeApp && mailroomNativeApp.status === NativeAppStatus.Active
      ),
  );

  return (
    <WelcomePageGuard
      shouldShowWelcomePage={shouldShowWelcomePage}
      isLoading={isFeatureFlagPending || isNativeAppLoading || isFeaturePending}
      welcomePagePath={mailroomWelcomeRoute}
    />
  );
};
